RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.SectionItemGroup = RivalIQ.views.CompositeView.extend({
        ui: {
            infoBubbles: '.fa-info-circle'
        },

        template: '#shellSectionItemGroupTemplate',
        tagName: 'li',

        className: 'section-item-group',
        childViewContainer: 'ul',
        childView: views.SectionItem,

        childViewOptions: function (model) {

            const result = {
                active: model.get('active')
            };

            return result;
        },

        serializeData: function () {
            const me = this;

            const model = me.model.toJSON();

            return _.defaults(model, {
                icon: '',
                className: '',
                target: '',
                isBetaItem: false,
                customLabel: null,
                showTooltip: false,
                displayName: model.name,
                description: model.description || ''
            });
        },

        attachPopovers: function () {
            const me = this;

            me.ui.infoBubbles.popover({
                trigger: 'hover',
                container: 'body',
                placement: 'auto right',
                html: true
            });
        },

        onRender: function () {
            const me = this;

            me.requestRenderedFrame(function () {
                me.attachPopovers();
            });
        },

        addChild: function (item) {
            const me = this;
            const itm = item.toJSON();
            if (_.isUndefined(itm.display) || _.result(itm, 'display')) {
                Marionette.CompositeView.prototype.addChild.apply(me, arguments);
            }
        }
    });

});
